<template>
  <div class="footer">
    <div class="footer-centre">
      <el-row class="footer-centre-top">
        <el-col :sm="24" :xs="24">     
            <el-col :sm="24" :xs="12">
              <div class="other f-fRegular mt15">
                <div class="" style="position: center;">
                  <span class="other-icon-tit" style="font-size: 18px;"> 联系电话: 138-6744-4374(微信同号)</span><br><br><br>
                  <span class="other-icon-tit" style="font-size: 18px;"> 邮箱: 3948822088@qq.com</span>
                </div>

                
              </div>
            </el-col>
        </el-col>

  
      </el-row>

      <el-divider class="bg-999 hidden-xs-only"></el-divider>
      <div class="record-number f-fRegular f-s12 f-w400">
        <p>
          © 2024-{{ date }} ©FaceBeauty, All Rights Reserved |
          <a href="https://beian.miit.gov.cn" target="_blank"
            >浙ICP备2025160021号-1</a
          >
        </p>
        <p>
          杭州彩视云科技有限公司
          
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { getEmail } from "@/api/index";
import { checkAddress } from '../utils/validate';

export default {
  data() {
    return {
    
      isPro: false,
      date: new Date().getFullYear(),
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path, to.path == '/meiyanSDK');
      this.isPro = to.path == '/meiyanSDK';
    }
  },
  created() {
    let res = this.$route.path;
    this.isPro = res == '/meiyanSDK';
  },
  methods: {
    //邮箱接口
    getEmail() {
      let data = {
        mailboxEmail: document.getElementById("email").value,
        mailboxSource: "web端",
      };

      getEmail(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "订阅成功",
            type: "success",
          });
          document.getElementById("email").value = null;
        }
      });
    },
    //邮箱订阅
    checkEmail(path) {
      var email = document.getElementById("email").value;
      var regex =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9_\.\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (regex.test(email)) {
        this.getEmail();
      } else {
        alert("请输入正确的邮箱");
      }
    },
    jump(path) {
      this.$router.push({ path });
    },
    checkAddress
  },
};
</script>

<style lang="scss">
.left-ul {
  &.hidden-sm-and-up {
    border-top: 1px solid #999;

    .el-collapse-item {
      .el-collapse-item__header {
        background: #151c29;
        color: #ffffff;
        border-bottom: 1px solid #999999;
        font-size: 16px;

        .el-icon-arrow-right:before {
          content: "+";
          font-size: 26px;
          font-weight: 500;
        }
      }

      .el-collapse-item__content {
        background: #151c29;
        color: #ffffff;
        font-size: 16px;
        line-height: 35px;
        padding: 15px 0;
      }
    }
  }
}
</style>
<style lang='scss' scoped>
$myBlue: #249cff;

.flex {
  width: 100%;
  justify-content: space-between;
}

.footer {
  width: calc(100% - 30px);
  padding: 0 15px;
  background: #151c29;

  .email input {
    color: white;
  }

  .footer-centre {
    max-width: 1245px;
    margin: auto;
    color: #999999;
    font-weight: 400;

    .footer-centre-top {
      padding-top: 48px;
    }
  }

  .logo-item {
    text-align: left;
    color: #fff;

    .logo {
      height: 61px;
    }

    .lang-btn {
      display: block;
      margin-top: 27px;
    }

    .other {
      font-size: 14px;

      .other-icon {
        .other-icon-tit {
          display: inline-block;
          width: 93px;
        }

        .wechat-icon {
          width: 90px;
          height: 90px;
          vertical-align: text-top;
        }
      }
    }
  }

  .left-ul {
    // width: 68.5%;
    text-align: left;

    .list {
      a {
        color: #999999;

        &:hover {
          color: $myBlue;
        }
      }

      line-height: 28px;

      .list-title {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 12px;
      }
    }
  }

  .right-img {
    margin-top: 70px;
    font-size: 14px;
    align-items: center;

    .email {
      .email-input {
        width: 142px;
        height: 16px;
        background: rgba(153, 153, 153, 0.3);
        border: 1px solid rgba($color: #999, $alpha: 0.5);
        padding: 5px;
        caret-color: #fff;
        margin: 0 8px 0 15px;
      }
      .email-button {
        color: #fff;
        background-color: #7869ff;
        border: #7869ff;
      }
    }
  }

  .lang-btn {
    display: inline-block;
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #ffffff;
    border-radius: 20px;
    text-align: center;

    img {
      width: 24px;
      margin-right: 13px;
      vertical-align: middle;
    }
  }

  .record-number {
    line-height: 26px;
    padding-bottom: 30px;
  }

  .serve:hover {
    color: #249cff;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .footer {
    .other {
      .other-icon {
        font-size: 12px;
      }
    }
  }

  .right-img {
    justify-content: center;
    margin-bottom: 30px;
  }
}
</style>